import React, { memo, forwardRef } from "react";
const SvgCapitalH = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M19.31 16.8h-6.62v5.04c0 .307-.047.553-.14.74a1.344 1.344 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.94.94 0 01-.42-.2 1.518 1.518 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V10.16c0-.293.047-.533.14-.72.093-.187.2-.333.32-.44a.94.94 0 01.42-.2c.147-.04.273-.06.38-.06.107 0 .233.02.38.06.147.027.28.093.4.2.133.107.247.253.34.44.093.187.14.427.14.72v4.48h6.62v-4.48c0-.293.047-.533.14-.72.093-.187.2-.333.32-.44a.94.94 0 01.42-.2c.147-.04.273-.06.38-.06.107 0 .233.02.38.06.147.027.28.093.4.2.133.107.247.253.34.44.093.187.14.427.14.72v11.68c0 .307-.047.553-.14.74a1.344 1.344 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.94.94 0 01-.42-.2 1.518 1.518 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V16.8z"
      />
    </svg>
  );
});
SvgCapitalH.displayName = "SvgCapitalH";
const MemoForwardRef = memo(SvgCapitalH);
export default MemoForwardRef;
